import { useEffect, useState } from "react";
import axios from "axios";
import "./psxTicker.css";

// const API_URL = "/~tauruson/data/";
const API_URL = "/ticker_proxy.php";
// const API_URL = "https://orbitsecurities.com.pk/ticker_proxy.php";

const PSXTicker = () => {
    console.log("PSXTicker rendered");

  const [stocks, setStocks] = useState([]);

  useEffect(() => {
    console.log("Fetching PSX data...");
    axios
      .get(API_URL, { responseType: "text" })
      .then((res) => {
        const parsed = JSON.parse(res.data);

        // Optional: top 40 by volume
        const sorted = parsed
          .sort((a, b) => Number(b.VOLUME) - Number(a.VOLUME))
          ;

        setStocks(sorted);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="ticker-wrapper">
      <div className="ticker-track">
        {[...stocks, ...stocks].map((s, i) => (
          <div className="ticker-item" key={i}>
            <span className="symbol">{s.SYMBOL}</span>

            <span className="price">
              {Number(s.PRICE).toFixed(2)}
            </span>

            <span
              className={`change ${
                s.COLOR === "GREEN" ? "up" : "down"
              }`}
            >
              {Number(s.CHANGE) > 0 ? "+" : ""}
              {s.CHANGE}
            </span>

            {/* <span className="volume">
              Vol {formatVolume(s.VOLUME)}
            </span> */}
            {/* <span className="separator">|</span> */}
          </div>
        ))}
      </div>
    </div>
  );
};

const formatVolume = (v) => {
  const n = Number(v);
  if (n >= 1e6) return (n / 1e6).toFixed(1) + "M";
  if (n >= 1e3) return (n / 1e3).toFixed(1) + "K";
  return n;
};

export default PSXTicker;
